import glamorous from 'glamorous'

const Separator = glamorous.div({
  border: 0, // override defaults
  borderTop: '1px solid #dedede !important',
  maxWidth: 444,
  margin: '0 auto',
  padding: 0,
  height: 0,
})

export default Separator
